import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminJotauditDashboardEncounters: build.query<
      GetV2AdminJotauditDashboardEncountersApiResponse,
      GetV2AdminJotauditDashboardEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/encounters`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          has_audit: queryArg.hasAudit,
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminJotauditDashboardEncountersByEncounterId: build.query<
      GetV2AdminJotauditDashboardEncountersByEncounterIdApiResponse,
      GetV2AdminJotauditDashboardEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/encounters/${queryArg.encounterId}`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminJotauditDashboardNotes: build.query<
      GetV2AdminJotauditDashboardNotesApiResponse,
      GetV2AdminJotauditDashboardNotesApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/notes` }),
    }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteId:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}`,
        }),
      }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistory:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}/history`,
        }),
      }),
    getV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevision:
      build.query<
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiResponse,
        GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/notes/detail/${queryArg.organizationId}/${queryArg.noteId}/revisions/${queryArg.revision}`,
        }),
      }),
    getV2AdminJotauditDashboardNotesByOrganizationId: build.query<
      GetV2AdminJotauditDashboardNotesByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardNotesByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/notes/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          page: queryArg.page,
          per_page: queryArg.perPage,
          min_quality_score: queryArg.minQualityScore,
          max_quality_score: queryArg.maxQualityScore,
          cpt_mismatch_only: queryArg.cptMismatchOnly,
          is_completed: queryArg.isCompleted,
        },
      }),
    }),
    getV2AdminJotauditDashboardOrganizations: build.query<
      GetV2AdminJotauditDashboardOrganizationsApiResponse,
      GetV2AdminJotauditDashboardOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/organizations`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminJotauditDashboardProviders: build.query<
      GetV2AdminJotauditDashboardProvidersApiResponse,
      GetV2AdminJotauditDashboardProvidersApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/providers` }),
    }),
    getV2AdminJotauditDashboardProvidersByOrganizationId: build.query<
      GetV2AdminJotauditDashboardProvidersByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardProvidersByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/providers/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardProvidersByOrganizationIdAndUserId: build.query<
      GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiResponse,
      GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/providers/${queryArg.organizationId}/${queryArg.userId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardRulesComplianceStatsByOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/compliance-stats/${queryArg.organizationId}`,
          params: {
            days: queryArg.days,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            user_ids: queryArg.userIds,
            rule_ids: queryArg.ruleIds,
            comparison_mode: queryArg.comparisonMode,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.ruleId}/audits/drilldown/${queryArg.organizationId}`,
          params: {
            compliance_status: queryArg.complianceStatus,
            days: queryArg.days,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            user_ids: queryArg.userIds,
            page: queryArg.page,
            per_page: queryArg.perPage,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationId:
      build.query<
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiResponse,
        GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.pathRuleId}/audits/${queryArg.organizationId}`,
          params: {
            rule_id: queryArg.queryRuleId,
            page: queryArg.page,
            per_page: queryArg.perPage,
          },
        }),
      }),
    getV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationId: build.query<
      GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/rules/${queryArg.ruleId}/stats/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2AdminJotauditDashboardStats: build.query<
      GetV2AdminJotauditDashboardStatsApiResponse,
      GetV2AdminJotauditDashboardStatsApiArg
    >({
      query: () => ({ url: `/v2/admin/jotaudit/dashboard/stats` }),
    }),
    getV2AdminJotauditDashboardStatsByOrganizationId: build.query<
      GetV2AdminJotauditDashboardStatsByOrganizationIdApiResponse,
      GetV2AdminJotauditDashboardStatsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/dashboard/stats/${queryArg.organizationId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    postV2AdminJotauditRun: build.mutation<
      PostV2AdminJotauditRunApiResponse,
      PostV2AdminJotauditRunApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/run`,
        method: "POST",
        body: queryArg.runAuditRequest,
      }),
    }),
    getV2AdminJotauditStatusByThreadId: build.query<
      GetV2AdminJotauditStatusByThreadIdApiResponse,
      GetV2AdminJotauditStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/jotaudit/status/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderJotauditDashboardEncounters: build.query<
      GetV2ProviderJotauditDashboardEncountersApiResponse,
      GetV2ProviderJotauditDashboardEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/encounters`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          has_audit: queryArg.hasAudit,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderJotauditDashboardEncountersByEncounterId: build.query<
      GetV2ProviderJotauditDashboardEncountersByEncounterIdApiResponse,
      GetV2ProviderJotauditDashboardEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2ProviderJotauditDashboardNotes: build.query<
      GetV2ProviderJotauditDashboardNotesApiResponse,
      GetV2ProviderJotauditDashboardNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/notes`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          page: queryArg.page,
          per_page: queryArg.perPage,
          min_quality_score: queryArg.minQualityScore,
          max_quality_score: queryArg.maxQualityScore,
          cpt_mismatch_only: queryArg.cptMismatchOnly,
          is_completed: queryArg.isCompleted,
        },
      }),
    }),
    getV2ProviderJotauditDashboardNotesByNoteId: build.query<
      GetV2ProviderJotauditDashboardNotesByNoteIdApiResponse,
      GetV2ProviderJotauditDashboardNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/notes/${queryArg.noteId}`,
      }),
    }),
    getV2ProviderJotauditDashboardNotesByNoteIdHistory: build.query<
      GetV2ProviderJotauditDashboardNotesByNoteIdHistoryApiResponse,
      GetV2ProviderJotauditDashboardNotesByNoteIdHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/notes/${queryArg.noteId}/history`,
      }),
    }),
    getV2ProviderJotauditDashboardProviders: build.query<
      GetV2ProviderJotauditDashboardProvidersApiResponse,
      GetV2ProviderJotauditDashboardProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/providers`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2ProviderJotauditDashboardProvidersByUserId: build.query<
      GetV2ProviderJotauditDashboardProvidersByUserIdApiResponse,
      GetV2ProviderJotauditDashboardProvidersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/providers/${queryArg.userId}`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2ProviderJotauditDashboardRulesComplianceStats: build.query<
      GetV2ProviderJotauditDashboardRulesComplianceStatsApiResponse,
      GetV2ProviderJotauditDashboardRulesComplianceStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/rules/compliance-stats`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          rule_ids: queryArg.ruleIds,
          comparison_mode: queryArg.comparisonMode,
        },
      }),
    }),
    getV2ProviderJotauditDashboardRulesByRuleIdAudits: build.query<
      GetV2ProviderJotauditDashboardRulesByRuleIdAuditsApiResponse,
      GetV2ProviderJotauditDashboardRulesByRuleIdAuditsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/rules/${queryArg.ruleId}/audits`,
      }),
    }),
    getV2ProviderJotauditDashboardRulesByRuleIdAuditsDrilldown: build.query<
      GetV2ProviderJotauditDashboardRulesByRuleIdAuditsDrilldownApiResponse,
      GetV2ProviderJotauditDashboardRulesByRuleIdAuditsDrilldownApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/rules/${queryArg.ruleId}/audits/drilldown`,
        params: {
          compliance_status: queryArg.complianceStatus,
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderJotauditDashboardRulesByRuleIdStats: build.query<
      GetV2ProviderJotauditDashboardRulesByRuleIdStatsApiResponse,
      GetV2ProviderJotauditDashboardRulesByRuleIdStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/rules/${queryArg.ruleId}/stats`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2ProviderJotauditDashboardStats: build.query<
      GetV2ProviderJotauditDashboardStatsApiResponse,
      GetV2ProviderJotauditDashboardStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/dashboard/stats`,
        params: {
          days: queryArg.days,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          user_ids: queryArg.userIds,
        },
      }),
    }),
    getV2ProviderJotauditNotesByNoteId: build.query<
      GetV2ProviderJotauditNotesByNoteIdApiResponse,
      GetV2ProviderJotauditNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/notes/${queryArg.noteId}`,
      }),
    }),
    postV2ProviderJotauditNotesByNoteIdReaudit: build.mutation<
      PostV2ProviderJotauditNotesByNoteIdReauditApiResponse,
      PostV2ProviderJotauditNotesByNoteIdReauditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/notes/${queryArg.noteId}/reaudit`,
        method: "POST",
      }),
    }),
    getV2ProviderJotauditStatusByThreadId: build.query<
      GetV2ProviderJotauditStatusByThreadIdApiResponse,
      GetV2ProviderJotauditStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/status/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderJotauditStreamByThreadId: build.query<
      GetV2ProviderJotauditStreamByThreadIdApiResponse,
      GetV2ProviderJotauditStreamByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotaudit/stream/${queryArg.threadId}`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminJotauditDashboardEncountersApiResponse =
  /** status 200 OK */ EncounterAuditListResponse;
export type GetV2AdminJotauditDashboardEncountersApiArg = {
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Filter to encounters with/without audits (true=with audit, false=without audit) */
  hasAudit?: boolean | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
  /** Organization ID to filter encounters by (required for admin) */
  organizationId: string;
};
export type GetV2AdminJotauditDashboardEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterAuditDetailResponse;
export type GetV2AdminJotauditDashboardEncountersByEncounterIdApiArg = {
  encounterId: string;
  /** Organization ID for context (required for admin) */
  organizationId: string;
};
export type GetV2AdminJotauditDashboardNotesApiResponse =
  /** status 200 OK */ NoteAuditListResponse;
export type GetV2AdminJotauditDashboardNotesApiArg = void;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiResponse =
  /** status 200 OK */ NoteAuditDetailResponse3;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdApiArg =
  {
    organizationId: string;
    noteId: string;
  };
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiResponse =
  /** status 200 OK */ RevisionHistoryResponse;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdHistoryApiArg =
  {
    organizationId: string;
    noteId: string;
  };
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiResponse =
  /** status 200 OK */ AuditRevisionDetailResponse4;
export type GetV2AdminJotauditDashboardNotesDetailByOrganizationIdAndNoteIdRevisionsRevisionApiArg =
  {
    organizationId: string;
    noteId: string;
    revision: number;
  };
export type GetV2AdminJotauditDashboardNotesByOrganizationIdApiResponse =
  /** status 200 OK */ NoteAuditListResponse;
export type GetV2AdminJotauditDashboardNotesByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
  /** Minimum quality score (1-5) */
  minQualityScore?: number | null;
  /** Maximum quality score (1-5) */
  maxQualityScore?: number | null;
  /** Filter to only notes with CPT code mismatches */
  cptMismatchOnly?: boolean | null;
  /** Filter by completion status (true=completed/signed, false=unsigned/draft) */
  isCompleted?: boolean | null;
};
export type GetV2AdminJotauditDashboardOrganizationsApiResponse =
  /** status 200 OK */ OrganizationListResponse;
export type GetV2AdminJotauditDashboardOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
};
export type GetV2AdminJotauditDashboardProvidersApiResponse =
  /** status 200 OK */ ProviderListResponse;
export type GetV2AdminJotauditDashboardProvidersApiArg = void;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdApiResponse =
  /** status 200 OK */ ProviderListResponse;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiResponse =
  /** status 200 OK */ ProviderSummaryResponse2;
export type GetV2AdminJotauditDashboardProvidersByOrganizationIdAndUserIdApiArg =
  {
    organizationId: string;
    userId: string;
    /** Period in days (default 30) */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
  };
export type GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiResponse =
  /** status 200 OK */ RuleComplianceStatsListResponse;
export type GetV2AdminJotauditDashboardRulesComplianceStatsByOrganizationIdApiArg =
  {
    organizationId: string;
    /** Period in days */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
    /** Comma-separated rule IDs to filter by */
    ruleIds?: string | null;
    /** Include per-provider breakdown in aggregations */
    comparisonMode?: boolean | null;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiResponse =
  /** status 200 OK */ RuleAuditsListResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsDrilldownAndOrganizationIdApiArg =
  {
    ruleId: string;
    organizationId: string;
    /** Filter by compliance status: 'yes', 'warning', or 'no' */
    complianceStatus?: string | null;
    /** Period in days */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
    /** Page number (default 1) */
    page?: number;
    /** Items per page (default 20, max 100) */
    perPage?: number;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiResponse =
  /** status 200 OK */ AuditsByRuleResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdAuditsAndOrganizationIdApiArg =
  {
    pathRuleId: string;
    organizationId: string;
    /** Rule ID to search for */
    queryRuleId: string;
    page?: number;
    perPage?: number;
  };
export type GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiResponse =
  /** status 200 OK */ RuleDetailStatsResponse;
export type GetV2AdminJotauditDashboardRulesByRuleIdStatsAndOrganizationIdApiArg =
  {
    ruleId: string;
    organizationId: string;
    /** Period in days (default 30) */
    days?: number | null;
    /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
    dateFrom?: string | null;
    /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
    dateTo?: string | null;
    /** Comma-separated provider IDs to filter by */
    userIds?: string | null;
  };
export type GetV2AdminJotauditDashboardStatsApiResponse =
  /** status 200 OK */ GlobalDashboardStatsResponse;
export type GetV2AdminJotauditDashboardStatsApiArg = void;
export type GetV2AdminJotauditDashboardStatsByOrganizationIdApiResponse =
  /** status 200 OK */ OrgDashboardStatsResponse;
export type GetV2AdminJotauditDashboardStatsByOrganizationIdApiArg = {
  organizationId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type PostV2AdminJotauditRunApiResponse =
  /** status 200 OK */ RunAuditResponse;
export type PostV2AdminJotauditRunApiArg = {
  runAuditRequest: RunAuditRequest;
};
export type GetV2AdminJotauditStatusByThreadIdApiResponse =
  /** status 200 OK */ AuditStatusResponse;
export type GetV2AdminJotauditStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderJotauditDashboardEncountersApiResponse =
  /** status 200 OK */ EncounterAuditListResponse;
export type GetV2ProviderJotauditDashboardEncountersApiArg = {
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Filter to encounters with/without audits (true=with audit, false=without audit) */
  hasAudit?: boolean | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
};
export type GetV2ProviderJotauditDashboardEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterAuditDetailResponse;
export type GetV2ProviderJotauditDashboardEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderJotauditDashboardNotesApiResponse =
  /** status 200 OK */ NoteAuditListResponse;
export type GetV2ProviderJotauditDashboardNotesApiArg = {
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
  /** Minimum quality score (1-5) */
  minQualityScore?: number | null;
  /** Maximum quality score (1-5) */
  maxQualityScore?: number | null;
  /** Filter to only notes with CPT code mismatches */
  cptMismatchOnly?: boolean | null;
  /** Filter by completion status (true=completed/signed, false=unsigned/draft) */
  isCompleted?: boolean | null;
};
export type GetV2ProviderJotauditDashboardNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteAuditDetailResponse3;
export type GetV2ProviderJotauditDashboardNotesByNoteIdApiArg = {
  noteId: string;
};
export type GetV2ProviderJotauditDashboardNotesByNoteIdHistoryApiResponse =
  /** status 200 OK */ RevisionHistoryResponse;
export type GetV2ProviderJotauditDashboardNotesByNoteIdHistoryApiArg = {
  noteId: string;
};
export type GetV2ProviderJotauditDashboardProvidersApiResponse =
  /** status 200 OK */ ProviderListResponse;
export type GetV2ProviderJotauditDashboardProvidersApiArg = {
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2ProviderJotauditDashboardProvidersByUserIdApiResponse =
  /** status 200 OK */ ProviderSummaryResponse2;
export type GetV2ProviderJotauditDashboardProvidersByUserIdApiArg = {
  userId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2ProviderJotauditDashboardRulesComplianceStatsApiResponse =
  /** status 200 OK */ RuleComplianceStatsListResponse;
export type GetV2ProviderJotauditDashboardRulesComplianceStatsApiArg = {
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Comma-separated rule IDs to filter by */
  ruleIds?: string | null;
  /** Include per-provider breakdown in aggregations */
  comparisonMode?: boolean | null;
};
export type GetV2ProviderJotauditDashboardRulesByRuleIdAuditsApiResponse =
  /** status 200 OK */ AuditsByRuleResponse;
export type GetV2ProviderJotauditDashboardRulesByRuleIdAuditsApiArg = {
  ruleId: string;
};
export type GetV2ProviderJotauditDashboardRulesByRuleIdAuditsDrilldownApiResponse =
  /** status 200 OK */ RuleAuditsListResponse;
export type GetV2ProviderJotauditDashboardRulesByRuleIdAuditsDrilldownApiArg = {
  ruleId: string;
  /** Filter by compliance status: 'yes', 'warning', or 'no' */
  complianceStatus?: string | null;
  /** Period in days */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
  /** Page number (default 1) */
  page?: number;
  /** Items per page (default 20, max 100) */
  perPage?: number;
};
export type GetV2ProviderJotauditDashboardRulesByRuleIdStatsApiResponse =
  /** status 200 OK */ RuleDetailStatsResponse;
export type GetV2ProviderJotauditDashboardRulesByRuleIdStatsApiArg = {
  ruleId: string;
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2ProviderJotauditDashboardStatsApiResponse =
  /** status 200 OK */ OrgDashboardStatsResponse;
export type GetV2ProviderJotauditDashboardStatsApiArg = {
  /** Period in days (default 30) */
  days?: number | null;
  /** Explicit start date (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) */
  dateFrom?: string | null;
  /** Explicit end date (ISO 8601 format, e.g., 2024-01-31T23:59:59Z) */
  dateTo?: string | null;
  /** Comma-separated provider IDs to filter by */
  userIds?: string | null;
};
export type GetV2ProviderJotauditNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteAuditDetailResponse3;
export type GetV2ProviderJotauditNotesByNoteIdApiArg = {
  noteId: string;
};
export type PostV2ProviderJotauditNotesByNoteIdReauditApiResponse =
  /** status 200 OK */ RunAuditResponse;
export type PostV2ProviderJotauditNotesByNoteIdReauditApiArg = {
  noteId: string;
};
export type GetV2ProviderJotauditStatusByThreadIdApiResponse =
  /** status 200 OK */ AuditStatusResponse;
export type GetV2ProviderJotauditStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderJotauditStreamByThreadIdApiResponse = unknown;
export type GetV2ProviderJotauditStreamByThreadIdApiArg = {
  threadId: string;
};
export type AppointmentInfoResponse = {
  /** Appointment identifier */
  appointment_id: string;
  /** Appointment display color */
  color?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Appointment start time */
  start_time?: string | null;
  /** Appointment status */
  status?: string | null;
  /** Whether appointment is telehealth */
  telehealth?: boolean;
  /** Appointment title */
  title?: string | null;
};
export type CptAnalysisInfo = {
  /** Whether CPT analysis was actually performed */
  cpt_analysis_performed?: boolean;
  /** Whether target codes match recommended codes */
  cpt_match?: boolean;
  /** CPT codes originally selected by the provider */
  provider_cpt_codes?: string[] | null;
  /** AI-recommended CPT codes based on documentation */
  recommended_cpt_codes?: string[] | null;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[];
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
};
export type PatientInfoResponse = {
  /** Date of birth (YYYY-MM-DD) */
  dob?: string | null;
  /** Patient email address */
  email?: string | null;
  /** Patient first name */
  first_name?: string | null;
  /** Patient gender */
  gender?: string | null;
  /** Patient last name */
  last_name?: string | null;
  /** Patient mobile phone */
  mobile_phone?: string | null;
  /** Patient identifier */
  patient_id: string;
  /** Patient preferred name */
  preferred_name?: string | null;
  /** Patient pronouns */
  pronouns?: string | null;
};
export type EncounterAuditSummaryResponse = {
  /** Full appointment information */
  appointment?: AppointmentInfoResponse | null;
  /** Associated appointment ID */
  appointment_id?: string | null;
  /** Detailed CPT analysis from the most recent audit revision */
  cpt_analysis?: CptAnalysisInfo | null;
  /** Encounter identifier */
  encounter_id: string;
  /** Whether audit exists */
  has_audit?: boolean;
  /** Whether the main note has been signed */
  is_signed?: boolean;
  /** When most recent audit was performed */
  last_audit_at?: string | null;
  /** Most recent compliance percentage (0-100) */
  latest_compliance_pct?: number | null;
  /** Most recent CPT match status */
  latest_cpt_match?: boolean | null;
  /** Most recent quality score (1-5) */
  latest_quality_score?: number | null;
  /** Encounter modality: in_person, video, audio */
  modality?: string | null;
  /** Main note ID from encounter */
  note_id?: string | null;
  /** Full patient information */
  patient?: PatientInfoResponse | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** When encounter was scheduled */
  scheduled_for?: string | null;
  /** Session type information from analysis */
  session_type?: {
    [key: string]: any;
  } | null;
  /** Encounter status: pending, processing, completed */
  status: string;
  /** Brief summary from encounter analysis */
  summary?: string | null;
  /** Provider ID */
  user_id: string;
};
export type EncounterAuditListResponse = {
  encounters?: EncounterAuditSummaryResponse[];
  /** Whether more pages exist */
  has_more?: boolean;
  /** Current page number */
  page?: number;
  /** Items per page */
  per_page?: number;
  /** Total number of encounters */
  total?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type AppointmentInfoResponse2 = {
  /** Appointment identifier */
  appointment_id: string;
  /** Appointment display color */
  color?: string | null;
  /** Appointment duration in minutes */
  duration?: number | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Appointment start time */
  start_time?: string | null;
  /** Appointment status */
  status?: string | null;
  /** Whether appointment is telehealth */
  telehealth?: boolean;
  /** Appointment title */
  title?: string | null;
};
export type NoteAuditSummaryResponse = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
};
export type AuditRevisionDetailResponse = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse = {
  audit: NoteAuditSummaryResponse;
  current_revision?: AuditRevisionDetailResponse | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse | null;
};
export type PatientInfoResponse2 = {
  /** Date of birth (YYYY-MM-DD) */
  dob?: string | null;
  /** Patient email address */
  email?: string | null;
  /** Patient first name */
  first_name?: string | null;
  /** Patient gender */
  gender?: string | null;
  /** Patient last name */
  last_name?: string | null;
  /** Patient mobile phone */
  mobile_phone?: string | null;
  /** Patient identifier */
  patient_id: string;
  /** Patient preferred name */
  preferred_name?: string | null;
  /** Patient pronouns */
  pronouns?: string | null;
};
export type EncounterAuditDetailResponse = {
  /** When analysis was performed */
  analyzed_at?: string | null;
  /** Full appointment information */
  appointment?: AppointmentInfoResponse2 | null;
  /** Associated appointment ID */
  appointment_id?: string | null;
  /** CPT codes on encounter */
  cpt_codes?: string[];
  /** Full encounter analysis data (summary, modality, participants, etc.) */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter identifier */
  encounter_id: string;
  /** ICD-10 codes on encounter */
  icd10_codes?: string[];
  /** Encounter modality: in_person, video, audio */
  modality?: string | null;
  /** All audits for notes in this encounter */
  note_audits?: NoteAuditDetailResponse[];
  /** Full patient information */
  patient?: PatientInfoResponse2 | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** When encounter was scheduled */
  scheduled_for?: string | null;
  /** Encounter status: pending, processing, completed */
  status: string;
  /** Provider ID */
  user_id: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type NoteAuditSummaryResponse2 = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
};
export type AuditRevisionDetailResponse2 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse2 = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse2 = {
  audit: NoteAuditSummaryResponse2;
  current_revision?: AuditRevisionDetailResponse2 | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse2 | null;
};
export type NoteAuditListResponse = {
  audits?: NoteAuditDetailResponse2[];
  has_more?: boolean;
  page?: number;
  per_page?: number;
  total?: number;
};
export type NoteAuditSummaryResponse3 = {
  /** When note was first completed */
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number;
  encounter_id?: string | null;
  first_audit_at: string;
  /** Whether note was completed when audited */
  is_completed?: boolean;
  last_audit_at: string;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean;
  latest_quality_score?: number | null;
  /** Status of the current revision for incremental saves */
  latest_status?: string;
  note_audit_id: string;
  note_id: string;
  /** Note title if available */
  note_title?: string | null;
  /** Patient ID if available */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number;
  user_id: string;
};
export type AuditRevisionDetailResponse3 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type TemplateInfoResponse3 = {
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Template organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template UUID */
  template_id: string;
  /** Template title */
  title: string;
  /** User ID who owns the template */
  user_id: string;
};
export type NoteAuditDetailResponse3 = {
  audit: NoteAuditSummaryResponse3;
  current_revision?: AuditRevisionDetailResponse3 | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Template used to generate the note */
  template?: TemplateInfoResponse3 | null;
};
export type AuditRevisionSummaryResponse = {
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  /** Change from previous revision */
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  /** Revision number */
  revision: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  /** What triggered this audit */
  trigger: string;
};
export type RevisionHistoryResponse = {
  note_id: string;
  revisions?: AuditRevisionSummaryResponse[];
};
export type AuditRevisionDetailResponse4 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type OrganizationSummaryResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  organization_id: string;
  /** Organization display name */
  organization_name?: string | null;
  total_notes_audited?: number;
  total_providers?: number;
};
export type OrganizationListResponse = {
  has_more?: boolean;
  organizations?: OrganizationSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ProviderSummaryResponse = {
  avg_quality_score?: number | null;
  /** Avg seconds between first audit and completion */
  avg_time_to_submit_seconds?: number | null;
  compliance_percentage?: number | null;
  compliance_trend?: string | null;
  cpt_accuracy_pct?: number | null;
  notes_clean?: number;
  notes_this_period?: number;
  provider_name?: string | null;
  quality_trend?: string | null;
  /** Notes that have been completed/signed */
  signed_count?: number;
  total_notes_audited?: number;
  /** Notes not yet completed/signed */
  unsigned_count?: number;
  user_id: string;
};
export type ProviderListResponse = {
  providers?: ProviderSummaryResponse[];
  total?: number;
};
export type ProviderSummaryResponse2 = {
  avg_quality_score?: number | null;
  /** Avg seconds between first audit and completion */
  avg_time_to_submit_seconds?: number | null;
  compliance_percentage?: number | null;
  compliance_trend?: string | null;
  cpt_accuracy_pct?: number | null;
  notes_clean?: number;
  notes_this_period?: number;
  provider_name?: string | null;
  quality_trend?: string | null;
  /** Notes that have been completed/signed */
  signed_count?: number;
  total_notes_audited?: number;
  /** Notes not yet completed/signed */
  unsigned_count?: number;
  user_id: string;
};
export type RuleComplianceStatsResponse = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  /** Audits where compliant */
  compliant_count?: number;
  /** True if the rule has been soft-deleted (historical data only) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Audits that violated */
  non_compliant_count?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Audits that evaluated this rule */
  total_audits?: number;
  /** % violated (0-100) */
  violation_rate?: number;
  /** Audits with warnings */
  warning_count?: number;
};
export type ProviderRuleComplianceResponse = {
  /** Provider display name */
  provider_name?: string | null;
  rules?: RuleComplianceStatsResponse[];
  /** Provider ID */
  user_id: string;
};
export type RuleComplianceStatsListResponse = {
  /** Per-provider breakdown (only in comparison_mode) */
  by_provider?: ProviderRuleComplianceResponse[] | null;
  /** Rule with highest compliance rate */
  most_compliant_rule?: RuleComplianceStatsResponse | null;
  /** Rule with highest violation rate */
  most_violated_rule?: RuleComplianceStatsResponse | null;
  /** Filter period in days */
  period_days?: number | null;
  rules?: RuleComplianceStatsResponse[];
  /** Total rules with stats */
  total_rules?: number;
};
export type RuleAuditItemResponse = {
  /** When audit was performed */
  audited_at: string;
  /** Compliance status for this rule: 'yes', 'warning', 'no' */
  compliance_status: string;
  /** Audit ID */
  note_audit_id: string;
  /** Note ID */
  note_id: string;
  /** Note title */
  note_title?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** LLM reasoning for the assessment */
  reasoning?: string | null;
  /** Revision number */
  revision: number;
  /** Provider ID */
  user_id: string;
};
export type RuleAuditsListResponse = {
  audits?: RuleAuditItemResponse[];
  has_more?: boolean;
  page?: number;
  per_page?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  total?: number;
};
export type AuditRevisionDetailResponse5 = {
  /** Full audit data including rule_compliance_assessments, flags, questions, etc. */
  audit_data?: {
    [key: string]: any;
  };
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean;
  cpt_match?: boolean;
  created_at: string;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision: number;
  rules_compliant?: number;
  rules_non_compliant?: number;
  rules_warning?: number;
  /** Revision status (in_progress, compliance_complete, completed) */
  status?: string;
  /** CPT codes used for rule selection and evaluation */
  target_cpt_codes?: string[] | null;
  /** Source of target codes: 'user' (from encounter) or 'ai' (recommended) */
  target_cpt_source?: string | null;
  trigger: string;
};
export type AuditsByRuleResponse = {
  has_more?: boolean;
  page?: number;
  per_page?: number;
  revisions?: AuditRevisionDetailResponse5[];
  rule_id: string;
  total?: number;
};
export type ProviderRuleBreakdown = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  compliant_count?: number;
  non_compliant_count?: number;
  /** Provider display name */
  provider_name?: string | null;
  total_audits?: number;
  /** Provider ID */
  user_id: string;
  warning_count?: number;
};
export type RuleComplianceStatsResponse2 = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  /** Audits where compliant */
  compliant_count?: number;
  /** True if the rule has been soft-deleted (historical data only) */
  is_deleted?: boolean;
  /** True if the rule is disabled for the organization (not active) */
  is_disabled?: boolean;
  /** Audits that violated */
  non_compliant_count?: number;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Audits that evaluated this rule */
  total_audits?: number;
  /** % violated (0-100) */
  violation_rate?: number;
  /** Audits with warnings */
  warning_count?: number;
};
export type RuleTrendDataPoint = {
  /** % compliant (0-100) */
  compliance_rate?: number;
  compliant_count?: number;
  non_compliant_count?: number;
  /** Period label (e.g., '2025-01-01' or '2025-W01') */
  period: string;
  total_audits?: number;
  warning_count?: number;
};
export type RuleDetailStatsResponse = {
  /** Stats per provider */
  by_provider?: ProviderRuleBreakdown[];
  /** Aggregated stats for this rule */
  overall: RuleComplianceStatsResponse2;
  /** Full rule content (markdown) */
  rule_body_md?: string | null;
  /** Rule identifier */
  rule_id: string;
  /** Rule display name */
  rule_name?: string | null;
  /** Compliance over time */
  trend?: RuleTrendDataPoint[];
  /** 'daily', 'weekly', or 'monthly' */
  trend_granularity?: string;
};
export type QualityDistributionResponse = {
  /** Count with score 1 */
  score_1?: number;
  /** Count with score 2 */
  score_2?: number;
  /** Count with score 3 */
  score_3?: number;
  /** Count with score 4 */
  score_4?: number;
  /** Count with score 5 */
  score_5?: number;
};
export type GlobalDashboardStatsResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_improvement?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  period_days?: number;
  quality_distribution?: QualityDistributionResponse;
  total_notes_audited?: number;
  total_organizations?: number;
  total_revenue_delta_cents?: number;
  total_revisions?: number;
};
export type QualityDistributionResponse2 = {
  /** Count with score 1 */
  score_1?: number;
  /** Count with score 2 */
  score_2?: number;
  /** Count with score 3 */
  score_3?: number;
  /** Count with score 4 */
  score_4?: number;
  /** Count with score 5 */
  score_5?: number;
};
export type OrgDashboardStatsResponse = {
  avg_compliance_pct?: number | null;
  avg_quality_improvement?: number | null;
  avg_quality_score?: number | null;
  cpt_match_rate?: number | null;
  notes_clean?: number;
  organization_id: string;
  period_days?: number;
  quality_distribution?: QualityDistributionResponse2;
  total_notes_audited?: number;
  total_revenue_delta_cents?: number;
  total_revisions?: number;
};
export type RunAuditResponse = {
  /** Task status (queued) */
  status: string;
  /** Celery task ID */
  task_id: string;
  /** Thread ID for state tracking */
  thread_id: string;
  /** Workflow name */
  workflow_name: string;
};
export type RunAuditRequest = {
  /** Note ID to audit */
  note_id: string;
  /** Organization ID (defaults to note's organization if not provided) */
  organization_id?: string | null;
};
export type RuleComplianceItem = {
  /** Compliance status: yes, warning, no */
  compliant: string;
  /** Reason for the compliance status */
  reason: string;
  /** Section IDs if applicable */
  relevant_sections?: string[] | null;
  /** Rule identifier */
  rule_id: string;
  /** Title of the rule for display purposes */
  rule_title?: string | null;
  /** Actionable suggestion (3-8 words) for fixing the issue. Only present for 'warning' or 'no' compliance. */
  suggestion?: string | null;
};
export type AuditStatusResponse = {
  /** Compliance percentage (available when completed) */
  compliance_percentage?: number | null;
  /** Note being audited */
  note_id?: string | null;
  /** Quality score 1-5 (available when completed) */
  overall_quality_score?: number | null;
  /** Per-rule compliance assessments */
  rule_compliance_assessments?: RuleComplianceItem[];
  /** Rule IDs used for audit */
  selected_rule_ids?: string[];
  /** Workflow status: pending, validated, compliance_evaluated, completed, error */
  status: string;
  /** Thread ID */
  thread_id: string;
};
